import {FC} from 'react'
import {Badge, BadgeProps} from '@/components/ui/badge/Badge'
import {TKey, useTranslation} from '@/translations/i18n'
import {MailLogStatus} from '@/features/mailer/types'

const STATUS_TO_VARIANT: Record<MailLogStatus, NonNullable<BadgeProps['variant']>> = {
    sent: 'success',
    failed: 'danger',
    bounced: 'orange',
    pending: 'neutral'
}

const STATUS_TO_LABEL: Record<MailLogStatus, TKey> = {
    sent: 'mailer:log_status_sent',
    failed: 'mailer:log_status_failed',
    bounced: 'mailer:log_status_bounced',
    pending: 'mailer:log_status_pending'
}

interface MailerBatchStatusBadgeProps {
    status: MailLogStatus
    size?: BadgeProps['size']
}

export const MailerBatchStatusBadge: FC<MailerBatchStatusBadgeProps> = ({status, size = 'sm'}) => {
    const {t} = useTranslation()
    return (
        <Badge variant={STATUS_TO_VARIANT[status]} size={size} shape="roundedRectangle">
            {t(STATUS_TO_LABEL[status])}
        </Badge>
    )
}
